import { render, staticRenderFns } from "./TrashIconButton.vue?vue&type=template&id=9304f3c2&scoped=true&lang=pug&"
var script = {}
import style0 from "./TrashIconButton.vue?vue&type=style&index=0&id=9304f3c2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9304f3c2",
  null
  
)

export default component.exports